module.exports = "/static/assets/d1e55eef3b2319cef99497283f02004c.png";